import initialState from './initialState';
import { FETCH_TAGTYPES, RECEIVE_TAGTYPES } from '../actions/actionTypes';

export default function tagTypesReducer(state = initialState.tagTypes, action) {
	let newState = {};
	switch (action.type) {
		case FETCH_TAGTYPES:
			return { ...state, fetching: true };
		case RECEIVE_TAGTYPES:
			newState.items = action.tagTypes.items;
			newState.pagination = action.tagTypes.pagination;
			newState.pagination.pageSizeOptions = state.pagination.pageSizeOptions;
			newState.search = action.tagTypes.search;
			newState.fetching = false;
			return newState;
		default:
			return state;
	}
}